import {useEffect, useState} from 'react';

const useCustomMetaTags = ({title = "", description = "", keywords = ""}) => {

  const [value, setValue] = useState({title, description, keywords})

  useEffect(() => {
    if (value?.title !== "") {
      const existingMetaTags = document.querySelectorAll('meta[data-react-custom="true"]');
      existingMetaTags.forEach(tag => tag.remove());

      const metaTitle = document.createElement('meta');
      metaTitle.setAttribute('name', 'title');
      metaTitle.setAttribute('content', value?.title);
      document.head.appendChild(metaTitle);

      const metaDescription = document.createElement('meta');
      metaDescription.setAttribute('name', 'description');
      metaDescription.setAttribute('content', value?.des);
      document.head.appendChild(metaDescription);

      const metaKeywords = document.createElement('meta');
      metaKeywords.setAttribute('name', 'keywords');
      metaKeywords.setAttribute('content', value?.key);
      document.head.appendChild(metaKeywords);

      return () => {
        metaTitle.remove();
        metaDescription.remove();
        metaKeywords.remove();
      };
    }
  }, [value]);

  return [setValue]
};

export default useCustomMetaTags;
